import api from './api.js'

export const isAuthenticated = () => {
    return api.get('/isAuth').then(response => true ).catch(err => false )
}
export const getToken = () => localStorage.getItem('token')
export const setToken = (token) => localStorage.setItem('token', token)
export const deleteToken = () => localStorage.removeItem('token')